// @generated by protoc-gen-grpc-gateway-es v0.5.0 with parameter "target=ts,generate_name_parser=true"
// @generated from file ai/h2o/mlops/deployer/v2/deployment_metadata_service.proto (package ai.h2o.mlops.deployer.v2, syntax proto3)
/* eslint-disable */

import type { DeploymentMetadata } from "./deployment_metadata_pb";
import type { Status } from "../../../../../google/rpc/status_pb";
import { RPC } from "../../../../../runtime";

/**
 * The request message for getting an deployment's metadata.
 *
 * @generated from message ai.h2o.mlops.deployer.v2.GetDeploymentMetadataRequest
 */
export type GetDeploymentMetadataRequest = {
/**
 * The name of the metadata deployment to get, in the form:
 * "workspaces/{workspace}/deployment/{deployment}/metadata"
 *
 * @generated from field: string name = 1;
 */
name: string;
}
;
/**
 * The response message for getting an deployment's metadata.
 *
 * @generated from message ai.h2o.mlops.deployer.v2.GetDeploymentMetadataResponse
 */
export type GetDeploymentMetadataResponse = {
/**
 * The retrieved deployment's metadata.
 *
 * @generated from field: ai.h2o.mlops.deployer.v2.DeploymentMetadata deployment_metadata = 1;
 */
deploymentMetadata?: DeploymentMetadata;
}
;
/**
 * The request message for BatchGetDeploymentsMetadata.
 *
 * @generated from message ai.h2o.mlops.deployer.v2.BatchGetDeploymentsMetadataRequest
 */
export type BatchGetDeploymentsMetadataRequest = {
/**
 * Required. The resource name of the workspace to get deployments metadata.
 * Format: `workspaces/{workspace}`
 *
 * @generated from field: string parent = 1;
 */
parent: string;
/**
 * The name of the metadata deployment to get.
 * // A maximum of 1000 metadata can be retrieved in a batch.
 * Format: "workspaces/{workspace}/deployment/{deployment}/metadata"
 *
 * @generated from field: repeated string names = 2;
 */
names: string[];
}
;
/**
 * The response message for getting BatchGetDeploymentsMetadata.
 *
 * (-- api-linter: core::0231::response-resource-field=disabled
 *     aip.dev/not-precedent: We need to do this because plural form of deploymentMetadata here is deploymentsMetadata. --)
 *
 * @generated from message ai.h2o.mlops.deployer.v2.BatchGetDeploymentsMetadataResponse
 */
export type BatchGetDeploymentsMetadataResponse = {
/**
 * The retrieved deployments' metadata.
 *
 * @generated from field: repeated ai.h2o.mlops.deployer.v2.DeploymentMetadata deployments_metadata = 1;
 */
deploymentsMetadata?: DeploymentMetadata[];
/**
 * Errors for specific deployments metadata
 *
 * @generated from field: map<string, google.rpc.Status> errors = 2;
 */
errors?: { [key: string]: Status };
}
;
/**
 * Retrieves a single deployment's metadata.
 *
 * @generated from rpc ai.h2o.mlops.deployer.v2.DeploymentMetadataService.GetDeploymentMetadata
 */
export const DeploymentMetadataService_GetDeploymentMetadata = new RPC<GetDeploymentMetadataRequest,GetDeploymentMetadataResponse>("GET", "/v2/{name=workspaces/*/deployments/*/metadata}");
/**
 * Retrieves a list of deployments metadata for provided names
 *
 * @generated from rpc ai.h2o.mlops.deployer.v2.DeploymentMetadataService.BatchGetDeploymentsMetadata
 */
export const DeploymentMetadataService_BatchGetDeploymentsMetadata = new RPC<BatchGetDeploymentsMetadataRequest,BatchGetDeploymentsMetadataResponse>("GET", "/v2/{parent=workspaces/*}/deployments/metadata:batchGet");
